module.exports = __webpack_public_path__ + "static/media/muted.178ad5da.svg";